import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landingRedesign.scss";
import "../../Assets/Styles/pages/faqPageRedesign.scss";
import Nav from "../../Components/LandingComponents/Nav";
import FAQHero from "../../Components/FAQComponents/FAQHero";
import FAQExplorer from "../../Components/FAQComponents/FAQExplorer";
import FAQContactCTA from "../../Components/FAQComponents/FAQContactCTA";
import usePageMetadata from "../../Utils/usePageMetadata";

// The global Footer still renders below every route including this one. The global Header's
// desktop bar is suppressed for "/faq" in Header.tsx's `condition()` -- Nav replaces it, same
// pattern as the landing/features/pricing pages.
const FAQ: React.FC = () => {
    usePageMetadata(
        "Frequently Asked Questions - eZy WaterMark",
        "Got questions about eZy Watermark? Find answers to frequently asked questions about picture safety, subscription plans, custom templates, supported formats, and more."
    );

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="landing-redesign">
            <Nav />
            <FAQHero />
            <FAQExplorer />
            <FAQContactCTA />
        </div>
    )

}

export default FAQ;
